<template>
  <div
    class="card-mobile-image"
    :style="reverse ? `flex-direction: row-reverse` : null"
  >
  
    <div class="img-container" :class="noBackground ? 'after-background' : 'after-background' ">
      <img :src="img" alt="" />
    </div>
    <div class="content">
      <h1>{{ title }}</h1>
      <p>
        {{ desc }}
      </p>
      <div class="learn-more">{{ $t('common.downloadTheApp') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['reverse', 'title', 'desc','img','noBackground'],
};
</script>

<style lang="scss" scoped>
.card-mobile-image {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 80px;
  margin-bottom: 100px;
}

.card-mobile-image > div {
  flex: 1;
}
.card-mobile-image > .img-container {
  flex: 1;
}

img {
  padding: 25px;
  max-height:500px;
  max-width:100%;
  filter:drop-shadow(-1px 30px 20px rgba(50, 50, 50, 0.127)) drop-shadow(10px 8px 5px rgba(0, 0, 0, 0.3))
}


.img-container {
  display: flex;
  justify-content: center;
  position: relative;
  
}
.after-background::after {
  content: '';
  position: absolute;
  left: 0px;
  height: 47%;
  width: 100%;
  bottom: 0px;
  background: #ff6286;
  background:linear-gradient(180deg, #FF6286ff, #FF5E84ff, #FF5A81ff, #FF567Fff, #FF527Cff, #FF4E7Aff, #FF4A77ff);
  border-radius: 10px;
  z-index: -1;
}
.content {
  display: flex;

  flex-direction: column;
  justify-content: end;
}

.content h1 {
  font-size: 35px !important;
  color: #ed2756;
  line-height: unset;
}

.content p {
  font-size: 16px !important;
  margin: 10px 0px 30px 0px;
  color: rgb(120, 120, 120);
  line-height: unset;
}

.learn-more {
  color: #ed2756;
  border: 1px solid #ed2756;
  padding: 12px 40px;
  width: fit-content;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;

}
@media (width < 768px) {
  .card-mobile-image {
    flex-direction: column !important;
    gap: 30px;
    margin-bottom: 40px;
  }
  img {
    padding: 20px;
    max-height:350px;}

    .content h1 {
      font-size: 22px !important;
      line-height:unset;
    }
    
    .content p {
      font-size: 16px !important;
      margin: 10px 0px 30px 0px;
      color: rgb(120, 120, 120);
    }
    .learn-more {
      padding: 8px 25px;
      border-radius: 5px;
      font-size: 16px;
    }
}
</style>